import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '@/components/i18n/LanguageSwitcher';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useMe } from '@/hooks/usePermissions';
import { EventSettingsCard } from './EventSettingsCard';

/**
 * Settings Page Component
 *
 * Sprache für jeden, darunter die Gruppe „Veranstaltungen" für alle, die
 * mindestens eine der VA-Vorlagen-Rechte besitzen.
 */
export function SettingsPage() {
  const { t } = useTranslation('settings');
  const { data: me } = useMe();
  /**
   * Am RECHT geprüft, nicht an der Rolle (29.09.2026 fix, wie
   * EventTextListPage.tsx's `canManage`, US-203) — vorher war dies
   * `role === Zentral || role === Admin` und sperrte damit jeden Partner
   * aus, obwohl die Vorlagenseiten selbst schon rechte-basiert und
   * Partner-fähig sind. Eines der beiden Rechte reicht, da die Karte zu
   * beiden Pflegeseiten verlinkt. `paymentNoteTemplates` bleibt bewusst
   * außen vor — diese dritte Pflegeseite ist weiterhin rollenbasiert
   * (`Zentral || Admin`), nicht Teil dieser Änderung.
   */
  const canManageEvents =
    (me?.permissions?.eventTexts ?? []).includes('edit') ||
    (me?.permissions?.cancellationTerms ?? []).includes('edit');

  return (
    <div className="container max-w-4xl py-8">
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">{t('title')}</h1>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>{t('language.title')}</CardTitle>
            <CardDescription>{t('language.description')}</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <LanguageSwitcher />
            </div>
          </CardContent>
        </Card>

        {canManageEvents && <EventSettingsCard />}
      </div>
    </div>
  );
}
